import React, { useEffect } from "react";
import { ApiResponse } from "../../../api/master/axiosIndex";
import { phaseApis } from "../../../api/Phase";
import { useDispatch } from "react-redux";
import { useLocation } from "react-router";
import { RootState } from "../../../store/store";
import { useSelector } from "react-redux";
import { Card } from "antd";
import StatusTimeLine from "../statusTimeLine/StatusTimeLine";

const PhaseStatusTimeLine = () => {
  const [timeLineData, setTimeLineData] = React.useState([]);
  const dispatch = useDispatch();
  const location = useLocation();
  const { id: projectId, extra: extraData } = location.state || {};
  const {
    data: {
      id: phaseId,
      open: phaseOpen,
      projectResponse: {
        isLocked: lock,
        lockedByName: lockedByUserName,
        updatedDate: lockedOn,
        plannedStartDate: projectStartDate,
        plannedEndDate: projectEndDate,
      },
      allowEdit,
      extra: { status },
    },
  } = useSelector((state: RootState) => state.PhaseInDetailModal);
  useEffect(() => {
    getStatusTimeLineData();
  }, []);
  const getStatusTimeLineData = async () => {
    try {
      const apiResponse: ApiResponse = await phaseApis.fetchPhaseStatusTimeline(
        projectId,
        phaseId
      );
      const { data, status } = apiResponse;
      if (status) {
        console.log("data", data);
        setTimeLineData(data);
      }
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <Card className="card-bordered mt-3" style={{ padding: "20px 50px" }}>
      <StatusTimeLine transitions={timeLineData} />
    </Card>
  );
};

export default PhaseStatusTimeLine;
